export class AreaBollalavoroModel {
  public type_user: any[] = [];
  public notes: string;
}
